"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsXdr = require("@stellar/js-xdr");
var cereal = {
  XdrWriter: _jsXdr.XdrWriter,
  XdrReader: _jsXdr.XdrReader
};
var _default = exports["default"] = cereal;